/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import AppDispatcher from '../core/AppDispatcher'
import nl2br from 'react-nl2br'
import onRequestLogout from './login/onRequestLogout'

export const ErrorActionTypes = {
  info: 'app/error-info',
  warn: 'app/error-warn',
  fatal: 'app/error-fatal'
}

export const errorActions = {
  showInformation: msg => {
    AppDispatcher.dispatchWithType(ErrorActionTypes.info, {
      level: 'info',
      message: msg
    })
  },

  showWarning: msg => {
    AppDispatcher.dispatchWithType(ErrorActionTypes.warn, {
      level: 'warn',
      message: msg
    })
  },

  showFatal: msg => {
    AppDispatcher.dispatchWithType(ErrorActionTypes.fatal, {
      level: 'fatal',
      message: msg
    })
  }
}

export const AppActionTypes = {
  loading: 'app/loading',
  loaded: 'app/loaded',
  snackbar: 'app/show-snackbar',
  disposeSnackbar: 'app/dispose-snackbar'
}

export const appActions = {
  isLoading: false,

  loading: () => {
    if (!this.isLoading) {
      this.isLoading = true
      AppDispatcher.dispatchWithType(AppActionTypes.loading)
    }
  },

  loaded: () => {
    if (this.isLoading) {
      this.isLoading = false
      AppDispatcher.dispatchWithType(AppActionTypes.loaded)
    }
  },

  showAlert: (errorClass, fallbackMsg) => {
    if (errorClass.status === 401) {
      onRequestLogout()
      return
    }

    const error = errorClass.response.body
    if (error.columns && error.columns instanceof Array) {
      appActions.snackbar(error.columns, 'error', true)
      return
    }

    if (error.columns instanceof Object) {
      const keys = Object.keys(error.columns)
      const errors = keys.map(index => {
        const row = parseInt(index, 10) + 1
        const err = error.columns[index]
        if (err instanceof Array) {
          return err.map(e => '#' + row + ' ' + e)
        }
        return '#' + row + ' ' + err
      })

      const flattenErrors = errors.reduce((acc, val) => acc.concat(val), [])
      appActions.snackbar(flattenErrors, 'error', true)
      return
    }

    if (error.message) {
      appActions.snackbar(error.message, 'error', true)
      return
    }
    appActions.snackbar(fallbackMsg, 'error', true)
  },

  showError: (error, fallbackMsg) => {
    // Deprecated
    if (error.columns && error.columns instanceof Array) {
      appActions.snackbar(error.columns, 'error', true)
      return
    }

    if (error.columns instanceof Object) {
      const keys = Object.keys(error.columns)
      const errors = keys.map(index => {
        const row = parseInt(index, 10) + 1
        const err = error.columns[index]
        if (err instanceof Array) {
          return err.map(e => '#' + row + ' ' + e)
        }
        return '#' + row + ' ' + err
      })

      const flattenErrors = errors.reduce((acc, val) => acc.concat(val), [])
      appActions.snackbar(flattenErrors, 'error', true)
      return
    }

    if (error.message) {
      appActions.snackbar(error.message, 'error', true)
      return
    }
    appActions.snackbar(fallbackMsg, 'error', true)
  },

  snackbar: (message, type, fadeout = 1500) => {
    if (message instanceof Array) {
      message = message.join('\n')
    }
    AppDispatcher.dispatchWithType(AppActionTypes.snackbar, {
      type: type,
      message: nl2br(message),
      fadeout: fadeout
    })
  },

  disposeSnackbar: () => {
    AppDispatcher.dispatchWithType(AppActionTypes.disposeSnackbar)
  }
}
